// src/pages/AcercaDe.jsx

import React from "react";
import "../css/acercade.css";

const FeatureIcon = ({ type }) => {
  const common = {
    className: "acercade-icon-svg",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
  };

  const strokeProps = {
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (type) {
    case "ventas":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M3 3v18h18" />
          <path {...strokeProps} d="M7 15l3-3 3 2 5-7" />
          <path {...strokeProps} d="M18 7h-4" />
          <path {...strokeProps} d="M18 7v4" />
        </svg>
      );

    case "logistica":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M10 17h4V5H2v12h3" />
          <path {...strokeProps} d="M14 17h1.5" />
          <path {...strokeProps} d="M22 17h-2" />
          <path {...strokeProps} d="M14 8h4l4 4v5" />
          <circle {...strokeProps} cx="7.5" cy="17.5" r="2.5" />
          <circle {...strokeProps} cx="17.5" cy="17.5" r="2.5" />
        </svg>
      );

    case "reportes":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M4 19V5" />
          <path {...strokeProps} d="M4 19h16" />
          <path {...strokeProps} d="M8 16v-5" />
          <path {...strokeProps} d="M12 16V8" />
          <path {...strokeProps} d="M16 16v-3" />
        </svg>
      );

    case "control":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
          <path {...strokeProps} d="m9 12 2 2 4-5" />
        </svg>
      );

    default:
      return (
        <svg {...common}>
          <circle {...strokeProps} cx="12" cy="12" r="9" />
          <path {...strokeProps} d="M12 8v4l3 2" />
        </svg>
      );
  }
};

const features = [
  {
    title: "Ventas y clientes",
    description: "Registro comercial, clientes compradores, receptores y trazabilidad de operaciones.",
    icon: "ventas",
  },
  {
    title: "Logística de pedidos",
    description: "Control de pedidos, agrupaciones, organización y seguimiento operativo.",
    icon: "logistica",
  },
  {
    title: "Reportes claros",
    description: "Informes por ventas, productos, finanzas, pedidos y estados de la operación.",
    icon: "reportes",
  },
  {
    title: "Control centralizado",
    description: "Información ordenada en una plataforma única para tomar mejores decisiones.",
    icon: "control",
  },
];

const AcercaDe = () => {
  return (
    <main className="acercade-riders">
      <section className="acercade-hero">
        <div className="acercade-kicker">Riders Miami Motorsports</div>

        <h1>Sistema de gestión comercial y logística</h1>

        <p>
          Plataforma diseñada para administrar ventas, clientes, productos,
          pedidos, pagos y reportes en un entorno simple, ordenado y seguro.
        </p>

        <div className="acercade-badges">
          <span>Versión 1.0</span>
          <span>React JS</span>
          <span>Node.js</span>
          <span>MongoDB</span>
        </div>
      </section>

      <section className="acercade-grid">
        {features.map((item) => (
          <article key={item.title} className="acercade-card">
            <div className="acercade-icon-box">
              <FeatureIcon type={item.icon} />
            </div>

            <h2>{item.title}</h2>

            <p>{item.description}</p>
          </article>
        ))}
      </section>

      <section className="acercade-info">
        <div>
          <h3>Objetivo del sistema</h3>

          <p>
            Mejorar el control operativo de Riders Miami mediante herramientas
            digitales que reduzcan tareas manuales, ordenen la información y
            faciliten el seguimiento de cada operación desde la venta hasta la
            preparación logística.
          </p>
        </div>

        <div className="acercade-version-card">
          <span>Versión actual</span>
          <strong>1.0</strong>
          <small>© {new Date().getFullYear()} Riders Miami. Todos los derechos reservados.</small>
        </div>
      </section>
    </main>
  );
};

export default AcercaDe;
